import React, { createContext, useContext, useState } from 'react';
import { format, startOfWeek } from 'date-fns';

const AllocationsContext = createContext();

export const useAllocations = () => useContext(AllocationsContext);

export const AllocationsProvider = ({ children }) => {
  const [currentContextDepot, setCurrentContextDepot] = useState('');
  const [currentContextWeek, setCurrentContextWeek] = useState(format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd'));

  const value = React.useMemo(() => ({
    currentContextDepot,
    setCurrentContextDepot,
    currentContextWeek,
    setCurrentContextWeek,
  }), [currentContextDepot, currentContextWeek]);

  return (
    <AllocationsContext.Provider value={value}>
      {children}
    </AllocationsContext.Provider>
  );
};